module.exports = __webpack_public_path__ + "static/media/icon-devolucao.e3ecd16d.svg";